import { PageViewEventLogger } from '@repo/tracking-service';
import { Spinner } from '@repo/ui';
import { GetServerSideProps } from 'next';
import { useEffect, useState } from 'react';

import { HometaxOverloadControlError } from '@/components/tax-refund/common/view/ErrorView/HometaxOverloadControlError';
import { createErrorPageLayout, parseTopNavButtonQuery } from '@/lib/utils/layout';

export const OverloadControlPage = ({ requestType }: { requestType: string }) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timerId = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => {
      clearTimeout(timerId);
    };
  }, []);

  if (isLoading) return <Spinner />;

  return (
    <PageViewEventLogger pageName="indis-talk_waiting_retry_later" eventProperty={{ type: requestType }}>
      <HometaxOverloadControlError />
    </PageViewEventLogger>
  );
};

OverloadControlPage.getLayout = createErrorPageLayout({ isNoticeVisible: false });

export const getServerSideProps = (async ({ query }) => {
  const topNavButtons = parseTopNavButtonQuery(query);
  return { props: { ...topNavButtons, requestType: (query['request-type'] as string) ?? 'checkDecision' } };
}) satisfies GetServerSideProps;

export default OverloadControlPage;
